import {apiBase} from 'api/base.js';

const EartagAlertConfigAPI = {
  index(farmId) {
    return apiBase.request(`/admin/eartag_alert_config?farm_id=${farmId}`, 'GET');
  },
  show(id, farmId) {
    return apiBase.request(`/admin/eartag_alert_config/${id}?farm_id=${farmId}`, 'GET');
  },
  create(params) {
    return apiBase.request('/admin/eartag_alert_config', 'POST', params);
  },
  update(id, farmId, params) {
    return apiBase.request(`/admin/eartag_alert_config/${id}?farm_id=${farmId}`, 'PUT', params);
  },
  delete(id, farmId) {
    return apiBase.request(`/admin/eartag_alert_config/${id}?farm_id=${farmId}`, 'DELETE');
  }
};

export {EartagAlertConfigAPI as eartagAlertConfigAPI};
